import { RefObject } from 'react';
import { useLocation } from 'react-router';
import useDidUpdateEffect from '../../../hooks/useDidUpdate';

export function useScrollToShowResults(
  ref: RefObject<HTMLDivElement>,
  offsetY?: number,
) {
  const location = useLocation();

  useDidUpdateEffect(() => {
    if (ref.current) {
      const y =
        ref.current.getBoundingClientRect().top +
        window.scrollY +
        (offsetY || 0);

      window.scroll({
        top: y,
        behavior: 'smooth',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);
}
